import { observable } from "mobx";
import { api_adm } from "../../api";
import { toast } from "react-toastify";

export class _TabelaSimplesExcessoStore {

  obs = observable({
    tabelasimples: [] as any,
  })

  async handleGetFaixas() {
    try {
      let resp = await api_adm.get(`/api/admin/tabelasimples/excesso/index`);

      this.obs.tabelasimples = [];
      this.obs.tabelasimples = resp.data

    } catch (ex) {
      toast.error("Erro ao carregar Tabela Simples Excesso!", {});
    }
  }

  async handleUpdateValue(id: string, campo: string, valor: number) {
    try {
      let params = {
        id: id, campo: campo, valor: valor
      }

      let resp = await api_adm.post(`/api/admin/tabelasimples/excesso/update`, params);

      if (resp.data.ok) {
        toast.success("Valor atualizado com sucesso!", {});
        return true

      } else {
        toast.error("Não foi possível atualizar valor, tente novamente mais tarde!", {});
        return false
      }

    } catch (ex) {
      toast.error("Erro ao atualizar valor, tente novamente mais tarde!", {});
      return false
    }
  }

  async handleCreate(params: any) {
    try {

      let resp = await api_adm.post(`/api/admin/tabelasimples/excesso/create`, params);

      if (resp.data.ok) {
        toast.success("Anexo criado com sucesso!", {});
        return true

      } else {
        toast.error("Não foi possível criar anexo, tente novamente mais tarde!", {});
        return false
      }

    } catch (ex) {
      toast.error("Erro ao criar anexo, tente novamente mais tarde!", {});
      return false
    }
  }

}

export const TabelaSimplesExcessoStore = new _TabelaSimplesExcessoStore();
